import React, { Component } from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import withAuth from "../../../components/withAuth";
import uuidV4 from "uuid/v4";

// STATE AND STORE
// LIBS
import API from "../../../api";
import Model from "../../../models/filials";
import validateForm from "../../../lib/helpers/validateForm";
import { sortFilialPercentsOnPriority } from "../../../lib/helpers/sort";
import {
  getFilialPercentFormString,
  getFilialPercentConditionString
} from "../../../lib/helpers/filials";

// UI
import {
  Alerts,
  Box,
  Button,
  Header,
  HeaderPage,
  Input,
  Table,
  ButtonGroup,
  Dropdown
} from "../../../ui";
import IconDelete from "../../../ui/src/ui/components/icons/delete";

class FilialPercentsEditPage extends Component {
  state = {
    titleHeader: "Изменение процентов",
    filial: {},
    formPercents: [],
    buttons: {
      condition: {
        list: [
          {
            id: "<",
            title: getFilialPercentConditionString("<"),
            onSelect: true,
            select: true
          },
          {
            id: "<=",
            title: getFilialPercentConditionString("<="),
            onSelect: true,
            select: true
          },
          {
            id: "=",
            title: getFilialPercentConditionString("="),
            onSelect: true,
            select: true
          },
          {
            id: ">",
            title: getFilialPercentConditionString(">"),
            onSelect: true,
            select: true
          },
          {
            id: ">=",
            title: getFilialPercentConditionString(">="),
            onSelect: true,
            select: true
          }
        ]
      },
      form: {
        list: [
          {
            id: "day",
            title: getFilialPercentFormString("day"),
            onSelect: true,
            select: true
          },
          {
            id: "sum",
            title: getFilialPercentFormString("sum"),
            onSelect: true,
            select: true
          }
        ]
      },
      save: {
        disabled: false
      }
    }
  };

  async componentDidMount() {
    const { id } = this.props.match.params;
    const filial = await API.filials.getOne(id);

    if (filial && filial.percents_list && filial.percents_list.length) {
      let formPercents = [];

      // Сортируем штрафы
      filial.percents_list.sort(sortFilialPercentsOnPriority);

      // Заполняем форму
      for (let percent of filial.percents_list) {
        formPercents.push({
          priority: {
            value: String(percent.priority) || "1",
            isEdited: false,
            isNumber: true,
            isError: false,
            errors: [],
            validate: Model.percents.priority
          },
          condition: {
            value: percent.condition || "",
            isEdited: false,
            isError: false,
            errors: [],
            validate: Model.percents.condition
          },
          form: {
            value: percent.form || "",
            isEdited: false,
            isError: false,
            errors: [],
            validate: Model.percents.form
          },
          target: {
            value: String(percent.target) || "0",
            isEdited: false,
            isNumber: true,
            isError: false,
            errors: [],
            validate: Model.percents.target
          },
          percent: {
            value: String(percent.percent) || "0",
            isEdited: false,
            isNumber: true,
            isError: false,
            errors: [],
            validate: Model.percents.percent
          }
        });
      }

      this.setState({ filial, formPercents });
    }
  }

  handleInput = e => {
    let value = e.target.value;
    let [priority, name] = String(e.target.name).split(":");
    const { formPercents } = this.state;

    for (let indexPercent in formPercents) {
      if (
        formPercents[indexPercent].priority.value === priority &&
        formPercents[indexPercent][name]
      ) {
        if (formPercents[indexPercent][name].isNumber) {
          value = String(value) || "";
        }

        formPercents[indexPercent][name] = {
          ...formPercents[indexPercent][name],
          value,
          isEdited: true,
          isError: false,
          errors: []
        };
      }
    }

    this.setState({ formPercents });
  };

  handleSelectDropdown(item, name, priority) {
    if (item && priority) {
      const { formPercents } = this.state;

      for (let indexPercent in formPercents) {
        if (
          formPercents[indexPercent].priority.value === priority &&
          formPercents[indexPercent][name]
        ) {
          let value = item.id;

          if (formPercents[indexPercent][name].isNumber) {
            value = String(value) || "";
          }

          formPercents[indexPercent][name] = {
            ...formPercents[indexPercent][name],
            value,
            isEdited: true,
            isError: false,
            errors: []
          };
        }
      }

      this.setState({ formPercents });
    }
  }

  handleAddRow = e => {
    e.preventDefault();

    let { formPercents } = this.state;

    formPercents.push({
      priority: {
        value: String(formPercents.length + 1 || 1),
        isEdited: false,
        isNumber: true,
        isError: false,
        errors: [],
        validate: Model.percents.priority
      },
      condition: {
        value: "",
        isEdited: false,
        isError: false,
        errors: [],
        validate: Model.percents.condition
      },
      form: {
        value: "",
        isEdited: false,
        isError: false,
        errors: [],
        validate: Model.percents.form
      },
      target: {
        value: "0",
        isEdited: false,
        isNumber: true,
        isError: false,
        errors: [],
        validate: Model.percents.target
      },
      percent: {
        value: "0",
        isEdited: false,
        isNumber: true,
        isError: false,
        errors: [],
        validate: Model.percents.percent
      }
    });

    this.setState({ formPercents });
  };

  handleDeleteRow = item => {
    let priority = item.priority.value;

    const { formPercents } = this.state;
    let formPercentsNew = [];

    console.log(item, formPercents);

    for (let percentItem of formPercents) {
      let priorityI = (percentItem && percentItem.priority.value) || null;

      if (priorityI !== priority) {
        formPercentsNew.push({
          ...percentItem,
          priority: {
            ...percentItem.priority,
            value: String(formPercentsNew.length + 1 || 1)
          }
        });
      }
    }

    this.setState({ formPercents: formPercentsNew });
  };

  handleFormSubmit = async e => {
    e.preventDefault();

    this.setState(prevState => {
      return {
        buttons: {
          ...prevState.buttons,
          save: {
            ...prevState.buttons.save,
            disabled: true
          }
        }
      };
    });

    const results = [];
    let isValid = true;
    const formPercentsValidate = this.state.formPercents;

    for (let indexPercent in formPercentsValidate) {
      results[indexPercent] = validateForm(
        this.state.formPercents[indexPercent]
      );
      formPercentsValidate[indexPercent] = results[indexPercent].form;

      if (!results[indexPercent].valid) {
        isValid = false;
      }
    }

    this.setState({ formPercents: formPercentsValidate });

    if (isValid) {
      const { formPercents } = this.state;
      const filialId = this.props.match.params.id;
      let isEdited = false;
      const percentsList = [];

      for (let indexPercents in formPercents) {
        const percentItem = {};

        for (let nameItem in formPercents[indexPercents]) {
          // Добавляем в объект
          percentItem[nameItem] = formPercents[indexPercents][nameItem].value;

          // Смотрим изменилось ли хотя бы одно поле?
          if (formPercents[indexPercents][nameItem].isEdited) {
            isEdited = true;
          }
        }

        // Добавляем в массив процентов
        percentsList.push(percentItem);
      }

      // Если изменения
      if (isEdited) {
        // Изменение текущего
        const resultUpdated = await API.filials.editOne(filialId, {
          percents_list: percentsList
        });

        if (resultUpdated) {
          Alerts.success("Проценты изменёны");

          // Включаем кнопку, данные сохранились
          this.setState(prevState => {
            return {
              buttons: {
                ...prevState.buttons,
                save: {
                  ...prevState.buttons.save,
                  disabled: false
                }
              }
            };
          });

          this.props.history.goBack();
        } else {
          Alerts.error("Проценты не изменёны");

          // Включаем кнопку, данные не сохранились
          this.setState(prevState => {
            return {
              buttons: {
                ...prevState.buttons,
                save: {
                  ...prevState.buttons.save,
                  disabled: false
                }
              }
            };
          });
        }
      } else {
        Alerts.alert("В процентах нет изменений");

        // Включаем кнопку, данные не сохранились
        this.setState(prevState => {
          return {
            buttons: {
              ...prevState.buttons,
              save: {
                ...prevState.buttons.save,
                disabled: false
              }
            }
          };
        });

        this.props.history.goBack();
      }
    } else {
      Alerts.warn("Валидация...");

      this.setState(prevState => {
        return {
          buttons: {
            ...prevState.buttons,
            save: {
              ...prevState.buttons.save,
              disabled: false
            }
          }
        };
      });
    }
  };

  getTableColumns = () => {
    return [
      {
        title: "Приоритет",
        suffix: "выбора условия",
        render: ({ item }) => {
          return (
            <Input
              type="integer"
              name={`${item.priority.value}:priority`}
              value={item.priority.value}
              disabled={true}
            />
          );
        }
      },
      {
        title: "Условие",
        suffix: "если",
        render: ({ item }) => {
          return (
            <Dropdown
              required={true}
              type="select"
              block={true}
              title="Выберите условие"
              errors={item.condition.errors}
              list={this.state.buttons.condition.list}
              selectedId={item.condition.value}
              onSelect={itemSelected => {
                this.handleSelectDropdown(
                  itemSelected,
                  "condition",
                  item.priority.value
                );
              }}
            />
          );
        }
      },
      {
        title: "Источник",
        suffix: "условия",
        render: ({ item }) => {
          return (
            <Dropdown
              type="select"
              block={true}
              title="Выберите источник"
              errors={item.form.errors}
              list={this.state.buttons.form.list}
              selectedId={item.form.value}
              onSelect={itemSelected => {
                this.handleSelectDropdown(
                  itemSelected,
                  "form",
                  item.priority.value
                );
              }}
              required
            />
          );
        }
      },
      {
        title: "Цель",
        suffix: "условия",
        text: "right",
        render: ({ item }) => {
          return (
            <Input
              type="number"
              name={`${item.priority.value}:target`}
              value={item.target.value}
              errors={item.target.errors}
              handleChange={this.handleInput}
            />
          );
        }
      },
      {
        title: "Процент",
        suffix: "тогда",
        text: "right",
        render: ({ item }) => {
          return (
            <Input
              type="number"
              name={`${item.priority.value}:percent`}
              value={item.percent.value}
              errors={item.percent.errors}
              handleChange={this.handleInput}
            />
          );
        }
      },
      {
        title: "",
        render: ({ item }) => {
          return (
            <Button
              theme="icon"
              name={`${item.priority.value}:delete`}
              onClick={() => this.handleDeleteRow(item)}
            >
              <IconDelete />
            </Button>
          );
        }
      }
    ];
  };

  getTableBody = () => {
    let list = [];

    for (let item of this.state.formPercents) {
      list.push(
        <tr key={uuidV4}>
          <td>
            <Input
              type="integer"
              name={`${item.priority.value}:priority`}
              value={item.priority.value}
              disabled={true}
            />
          </td>
          <td>
            <Dropdown
              required={true}
              type="select"
              block={true}
              title="Выберите условие"
              errors={item.condition.errors}
              list={this.state.buttons.condition.list}
              selectedId={item.condition.value}
              onSelect={itemSelected => {
                this.handleSelectDropdown(
                  itemSelected,
                  "condition",
                  item.priority.value
                );
              }}
            />
          </td>
          <td>
            <Dropdown
              type="select"
              block={true}
              title="Выберите источник"
              errors={item.form.errors}
              list={this.state.buttons.form.list}
              selectedId={item.form.value}
              onSelect={itemSelected => {
                this.handleSelectDropdown(
                  itemSelected,
                  "form",
                  item.priority.value
                );
              }}
              required
            />
          </td>
          <td>
            <Input
              type="number"
              name={`${item.priority.value}:target`}
              value={item.target.value}
              errors={item.target.errors}
              handleChange={this.handleInput}
            />
          </td>
          <td>
            <Input
              type="number"
              name={`${item.priority.value}:percent`}
              value={item.percent.value}
              errors={item.percent.errors}
              handleChange={this.handleInput}
            />
          </td>
          <td>
            <Button
              theme="icon"
              name={`${item.priority.value}:delete`}
              onClick={() => this.handleDeleteRow(item)}
            >
              <IconDelete />
            </Button>
          </td>
        </tr>
      );
    }

    return list;
  };

  render() {
    return (
      <div className="short">
        <Helmet>
          <title>{this.state.titleHeader}</title>
        </Helmet>

        <HeaderPage
          title={this.state.titleHeader}
          back={this.props.history.goBack}
        >
          <ButtonGroup>
            <Button
              type="submit"
              theme="success"
              onClick={this.handleFormSubmit}
              disabled={this.state.buttons.save.disabled}
            >
              Сохранить изменения
            </Button>
            <Button
              type="button"
              onClick={() => this.props.history.goBack()}
              theme="default"
            >
              Отмена
            </Button>
          </ButtonGroup>
        </HeaderPage>

        <form className="form" onSubmit={this.handleFormSubmit}>
          <Box>
            <Header size={4}>Проценты</Header>

            <Table
              columns={this.getTableColumns()}
              tbody={this.getTableBody()}
            />

            <Button
              theme="primary"
              onClick={this.handleAddRow}
              block={true}
              outline={true}
            >
              Добавить
            </Button>
          </Box>
        </form>
      </div>
    );
  }
}

const mapStateToProps = state => ({});

export default withAuth(connect(mapStateToProps)(FilialPercentsEditPage));
